// ─── Canvas Layout ────────────────────────────────────────────────────────────
export const CANVAS_WIDTH  = 800;
export const CANVAS_HEIGHT = 600;

export const LEFT_MARGIN   = 50;
export const RIGHT_MARGIN  = 50;
export const SDS_TOP_MARGIN    = 170;
export const SDS_BOTTOM_MARGIN = 50;
export const TOP_MARGIN_IEF    = 50;
export const IEF_BAND_HEIGHT   = 100;
export const PH_GRADIENT_Y      = 30;
export const PH_GRADIENT_HEIGHT = 10;

export const LOADING_ZONE_X    = 30;
export const LOADING_ZONE_Y    = 280;
export const LOADING_ZONE_SIZE = 40;

export const MAX_DISTANCE_TRAVELED = 20;

// ─── Dot Appearance ───────────────────────────────────────────────────────────
export const DOT_RADIUS       = 5;
export const DOT_HOVER_RADIUS = 8;
export const PULSE_RADIUS     = 14;
export const BAND_HEIGHT      = 40;

export const HIGHLIGHT_STROKE   = '#00d4aa';
export const HIGHLIGHT_LINEWIDTH = 2;
export const PULSE_STROKE       = 'rgba(0, 212, 170, 0.35)';

// ─── Colors ───────────────────────────────────────────────────────────────────
export const CANVAS_BG_COLOR    = '#0e0f14';
export const LOADING_ZONE_COLOR = '#1e2030';
export const GRID_STROKE        = '#ffffff';
export const ACID_COLOR    = '#e05555';
export const NEUTRAL_COLOR = '#00d4aa';
export const BASIC_COLOR   = '#4a9eff';
export const PROGRESS_BG   = '#1e2030';
export const PROGRESS_FILL = '#00d4aa';

// ─── Typography ───────────────────────────────────────────────────────────────
export const MAIN_FONT  = '11px "DM Mono", monospace';
export const SMALL_FONT = '10px "DM Mono", monospace';
export const FONT_COLOR = '#ffffff';

// ─── Progress bar ─────────────────────────────────────────────────────────────
export const PROGRESS_Y_OFFSET = 20;
export const PROGRESS_HEIGHT   = 3;

// ─── Zoom ─────────────────────────────────────────────────────────────────────
export const MIN_ZOOM = 0.95;
export const MAX_ZOOM = 5;
